import { Icon } from 'bold-ui'
import { useSession } from 'components/auth/useSession'
import { useDataCriacaoAgendadoQuery } from 'graphql/hooks.generated'
import { useServerTime } from 'hooks/useServerTime'
import { useCallback } from 'react'
import { JustificativaCancelamentoAgendaComboEnum as JustificativaEnum } from 'types/enums'
import { EventoAgendaLotacao } from 'view/agenda/model-agenda'

import MenuAcoesAgendamentoButton from '../MenuAcoesAgendamentoButton'
import { AcaoAgendamentoButtonProps } from '../model-acoesAgendamento'
import { agendamentoRegistradoEarlierThanOneHour, createJustificativaProfissional } from '../utils'

interface CancelarAgendamentoButtonProps extends Omit<AcaoAgendamentoButtonProps, 'event'> {
  event: Pick<
    EventoAgendaLotacao,
    'id' | 'tipo' | 'nomeCidadao' | 'motivoReserva' | 'dataCriacao' | 'lotacao' | 'isAtencaoDomiciliar'
  >
  openModalCancelarAgendamento(justificativa?: JustificativaEnum, justificativaOutra?: string): void
}

export function CancelarAgendamentoButton(props: Readonly<CancelarAgendamentoButtonProps>) {
  const { event, disabled, tooltip, isDropdown = false, openModalCancelarAgendamento } = props
  const {
    loading: loadingSessao,
    data: { profissional: { nome: nomeProfissional } = {}, acesso: { id: lotacaoId } = {} } = {},
  } = useSession({
    fetchPolicy: 'cache-first',
  })

  const { getServerTimeNow } = useServerTime()

  const { refetch, loading: loadingDataCriacaoAgendado } = useDataCriacaoAgendadoQuery({
    variables: { id: event.id },
    fetchPolicy: 'network-only',
    skip: true,
  })

  const loading = loadingSessao || loadingDataCriacaoAgendado

  const onClick = useCallback(async () => {
    const { data: { agendado } = {} } = await refetch()

    if (
      agendado?.dataCriacao &&
      nomeProfissional &&
      agendamentoRegistradoEarlierThanOneHour(agendado.dataCriacao, getServerTimeNow())
    ) {
      openModalCancelarAgendamento(
        JustificativaEnum.OUTRA,
        createJustificativaProfissional(nomeProfissional, getServerTimeNow())
      )
    } else if (event.tipo === 'reserva' && event.lotacao.id === lotacaoId) {
      openModalCancelarAgendamento(JustificativaEnum.JUSTIFICATIVA_AUTOMATICA_PROFISSIONAL)
    } else {
      openModalCancelarAgendamento()
    }
  }, [
    refetch,
    event.tipo,
    event.lotacao.id,
    lotacaoId,
    nomeProfissional,
    getServerTimeNow,
    openModalCancelarAgendamento,
  ])

  return (
    <MenuAcoesAgendamentoButton
      text='Cancelar'
      type='danger'
      tooltip={tooltip}
      disabled={disabled}
      loading={loading}
      isDropdown={isDropdown}
      onClick={onClick}
      icon={<Icon icon='trashOutline' />}
    />
  )
}
